module.exports = __webpack_public_path__ + "img/full-screen-icon.8a5ed217.svg";